<!-- Conditionally display header if content is provided -->
<div class="header">
    <ng-content select="[header]"></ng-content>
</div>

<!-- Modal body content -->
<div class="body">
    <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
    <ng-content select="[body]" *ngIf="!isLoading"></ng-content>
</div>

<!-- Conditionally display footer if content is provided -->
<div class="footer">
    <ng-content select="[footer]"></ng-content>
</div>
